import { mapActions, mapGetters, mapMutations } from "vuex";
import { VueSlideToggle } from "vue-slide-toggle";
import accordion from "./components/accordion/index.vue";
import accordionItem from "./components/accordion-item/index.vue";
import { dynamicHead } from "../../mixins/dynamic-head";
export default {
    name: "faq",
    data() {
        return {
            openFaq: false,
        };
    },
    mixins: [dynamicHead],
    inject: ["accordion"],
    components: {
        accordion,
        accordionItem,
        VueSlideToggle,
    },
    computed: {
        ...mapGetters({
            faq: "about/faq",
            seoData: "setting/seoData",
        }),
    },
    created() {
        this.getSeoData("faq").then(() => {
            this.setPageItem(this.seoData);
        });
        this.getFaq();
    },
    methods: {
        ...mapActions({
            getFaq: "about/GET_FAQ",
            getSeoData: "setting/GET_SEO_DATA",
        }),
        ...mapMutations({}),
    },
    destroyed() {},
};
